<template>

    <a-card :bordered="false">
      <div class="platformConfig">
        <a-alert type="warning" show-icon class="notice">
          <template slot="message">注意事项</template>
          <template slot="description">
            <ul class="notice-list">
              <li>医院、科室、医师三个页签的保存会触发相应分数重新计算，执行时间较长，请耐心等待提交完成。</li>
              <li>切换页签或取消编辑会丢弃当前页签未保存的修改，请先保存后再切换。</li>
            </ul>
          </template>
        </a-alert>
        <a-form ref="form" :model="form" layout="vertical">
          <a-tabs v-model="activeKey">
            <a-tab-pane key="1" tab="医院华歧系数规则配置">
              <a-row :gutter="20">
                <a-col :md="4" :sm="8">
                  <a-form-item label="医院简介" prop="hospitalContent">
                    <div class="num-wrap" :class="tabEditing ? 'is-editing' : 'is-readonly'"><a-input-number :min="0" v-model="form.hospitalContent" :disabled="!tabEditing" placeholder="请输入"></a-input-number><span class="suffix">分</span></div>
                  </a-form-item>
                </a-col>
                <a-col :md="4" :sm="8">
                  <a-form-item label="医院图片" prop="hospitalLogo">
                    <div class="num-wrap" :class="tabEditing ? 'is-editing' : 'is-readonly'"><a-input-number :min="0" v-model="form.hospitalLogo" :disabled="!tabEditing" placeholder="请输入"></a-input-number><span class="suffix">分</span></div>
                  </a-form-item>
                </a-col>
                <a-col :md="4" :sm="8">
                  <a-form-item label="有科室列表（有科室）" prop="haveDepart">
                    <div class="num-wrap" :class="tabEditing ? 'is-editing' : 'is-readonly'"><a-input-number :min="0" v-model="form.haveDepart" :disabled="!tabEditing" placeholder="请输入"></a-input-number><span class="suffix">分</span></div>
                  </a-form-item>
                </a-col>
                <a-col :md="4" :sm="8">
                  <a-form-item label="每个科室介绍" prop="eachDepartContent">
                    <div class="num-wrap" :class="tabEditing ? 'is-editing' : 'is-readonly'"><a-input-number :min="0" v-model="form.eachDepartContent" :disabled="!tabEditing" placeholder="请输入"></a-input-number><span class="suffix">分</span></div>
                  </a-form-item>
                </a-col>
              
                <a-col :md="4" :sm="8">
                  <a-form-item label="科室图片" prop="eachDepartLogo">
                    <div class="num-wrap" :class="tabEditing ? 'is-editing' : 'is-readonly'"><a-input-number :min="0" v-model="form.eachDepartLogo" :disabled="!tabEditing" placeholder="请输入"></a-input-number><span class="suffix">分</span></div>
                  </a-form-item>
                </a-col>
                <a-col :md="4" :sm="8">
                  <a-form-item label="医师简介" prop="eachDoctorContent">
                    <div class="num-wrap" :class="tabEditing ? 'is-editing' : 'is-readonly'"><a-input-number :min="0" v-model="form.eachDoctorContent" :disabled="!tabEditing" placeholder="请输入"></a-input-number><span class="suffix">分</span></div>
                  </a-form-item>
                </a-col>
                <a-col :md="4" :sm="8">
                  <a-form-item label="医院成功注册会员 三级医院（含甲乙丙）" prop="levelThreeRegister">
                    <div class="num-wrap" :class="tabEditing ? 'is-editing' : 'is-readonly'"><a-input-number :min="0" v-model="form.levelThreeRegister" :disabled="!tabEditing" placeholder="请输入"></a-input-number><span class="suffix">分</span></div>
                  </a-form-item>
                </a-col>
                <a-col :md="4" :sm="8">
                  <a-form-item label="医院成功注册会员 二级医院（含甲乙丙）" prop="levelTwoRegister">
                    <div class="num-wrap" :class="tabEditing ? 'is-editing' : 'is-readonly'"><a-input-number :min="0" v-model="form.levelTwoRegister" :disabled="!tabEditing" placeholder="请输入"></a-input-number><span class="suffix">分</span></div>
                  </a-form-item>
                </a-col>
              
                <a-col :md="4" :sm="8">
                  <a-form-item label=" 医院成功注册会员 一级医院（含甲乙丙）" prop="levelOneRegister">
                    <div class="num-wrap" :class="tabEditing ? 'is-editing' : 'is-readonly'"><a-input-number :min="0" v-model="form.levelOneRegister" :disabled="!tabEditing" placeholder="请输入"></a-input-number><span class="suffix">分</span></div>
                  </a-form-item>
                </a-col>
                <a-col :md="4" :sm="8">
                  <a-form-item label="三级医院（含甲乙丙）" prop="levelThreeHospital">
                    <div class="num-wrap" :class="tabEditing ? 'is-editing' : 'is-readonly'"><a-input-number :min="0" v-model="form.levelThreeHospital" :disabled="!tabEditing" placeholder="请输入"></a-input-number><span class="suffix">分</span></div>
                  </a-form-item>
                </a-col>
                <a-col :md="4" :sm="8">
                  <a-form-item label="二级医院（含甲乙丙）" prop="levelTwoHospital">
                    <div class="num-wrap" :class="tabEditing ? 'is-editing' : 'is-readonly'"><a-input-number :min="0" v-model="form.levelTwoHospital" :disabled="!tabEditing" placeholder="请输入"></a-input-number><span class="suffix">分</span></div>
                  </a-form-item>
                </a-col>
                <a-col :md="4" :sm="8">
                  <a-form-item label="一级医院（含甲乙丙）" prop="levelOneHospital">
                    <div class="num-wrap" :class="tabEditing ? 'is-editing' : 'is-readonly'"><a-input-number :min="0" v-model="form.levelOneHospital" :disabled="!tabEditing" placeholder="请输入"></a-input-number><span class="suffix">分</span></div>
                  </a-form-item>
                </a-col>
              
                <a-col :md="4" :sm="8">
                  <a-form-item label="专科医院（三级医院）" prop="specializedLevelThree">
                    <div class="num-wrap" :class="tabEditing ? 'is-editing' : 'is-readonly'"><a-input-number :min="0" v-model="form.specializedLevelThree" :disabled="!tabEditing" placeholder="请输入"></a-input-number><span class="suffix">分</span></div>
                  </a-form-item>
                </a-col>
                <a-col :md="4" :sm="8">
                  <a-form-item label="专科医院（二级医院）" prop="specializedLevelTwo">
                    <div class="num-wrap" :class="tabEditing ? 'is-editing' : 'is-readonly'"><a-input-number :min="0" v-model="form.specializedLevelTwo" :disabled="!tabEditing" placeholder="请输入"></a-input-number><span class="suffix">分</span></div>
                  </a-form-item>
                </a-col>
                <a-col :md="4" :sm="8">
                  <a-form-item label="专科医院（一级医院）" prop="specializedLevelOne">
                    <div class="num-wrap" :class="tabEditing ? 'is-editing' : 'is-readonly'"><a-input-number :min="0" v-model="form.specializedLevelOne" :disabled="!tabEditing" placeholder="请输入"></a-input-number><span class="suffix">分</span></div>
                  </a-form-item>
                </a-col>
              
                <a-col :md="4" :sm="8">
                  <a-form-item label="全国百强医院 1-10名" prop="oneToTen">
                    <div class="num-wrap" :class="tabEditing ? 'is-editing' : 'is-readonly'"><a-input-number :min="0" v-model="form.oneToTen" :disabled="!tabEditing" placeholder="请输入"></a-input-number><span class="suffix">分</span></div>
                  </a-form-item>
                </a-col>
                <a-col :md="4" :sm="8">
                  <a-form-item label="全国百强医院 11-20名" prop="elevenToTwenty">
                    <div class="num-wrap" :class="tabEditing ? 'is-editing' : 'is-readonly'"><a-input-number :min="0" v-model="form.elevenToTwenty" :disabled="!tabEditing" placeholder="请输入"></a-input-number><span class="suffix">分</span></div>
                  </a-form-item>
                </a-col>
                <a-col :md="4" :sm="8">
                  <a-form-item label="全国百强医院 21-30名" prop="twentyOneToThirty">
                    <div class="num-wrap" :class="tabEditing ? 'is-editing' : 'is-readonly'"><a-input-number :min="0" v-model="form.twentyOneToThirty" :disabled="!tabEditing" placeholder="请输入"></a-input-number><span class="suffix">分</span></div>
                  </a-form-item>
                </a-col>
              
                <a-col :md="4" :sm="8">
                  <a-form-item label="全国百强医院 31-50名" prop="thirtyOneToFifty">
                    <div class="num-wrap" :class="tabEditing ? 'is-editing' : 'is-readonly'"><a-input-number :min="0" v-model="form.thirtyOneToFifty" :disabled="!tabEditing" placeholder="请输入"></a-input-number><span class="suffix">分</span></div>
                  </a-form-item>
                </a-col>
                <a-col :md="4" :sm="8">
                  <a-form-item label="医院国内名医数量" prop="hospitalNationalFamousDoctorCount">
                    <div class="num-wrap" :class="tabEditing ? 'is-editing' : 'is-readonly'"><a-input-number :min="0" v-model="form.hospitalNationalFamousDoctorCount" :disabled="!tabEditing" placeholder="请输入"></a-input-number><span class="suffix">分</span></div>
                  </a-form-item>
                </a-col>
                <a-col :md="4" :sm="8">
                  <a-form-item label="医院省内名医数量" prop="hospitalProvinceFamousDoctorCount">
                    <div class="num-wrap" :class="tabEditing ? 'is-editing' : 'is-readonly'"><a-input-number :min="0" v-model="form.hospitalProvinceFamousDoctorCount" :disabled="!tabEditing" placeholder="请输入"></a-input-number><span class="suffix">分</span></div>
                  </a-form-item>
                </a-col>
              </a-row>
              <div class="tab-actions">
                <a-button v-if="!tabEditing" type="primary" @click="startEdit">编辑</a-button>
                <template v-else>
                  <a-button type="primary" :loading="submitLoading" @click="saveTab">保存</a-button>
                  <a-button :disabled="submitLoading" style="margin-left: 8px;" @click="cancelEdit">取消</a-button>
                </template>
              </div>
            </a-tab-pane>
            <a-tab-pane key="2" tab="科室华歧系数规则配置" force-render>

                <a-row :gutter="20">
                  <a-col :md="4" :sm="8">
                    <a-form-item label="科室介绍" prop="departContent">
                      <div class="num-wrap" :class="tabEditing ? 'is-editing' : 'is-readonly'"><a-input-number :min="0" v-model="form.departContent" :disabled="!tabEditing" placeholder="请输入"></a-input-number><span class="suffix">分</span></div>
                    </a-form-item>
                  </a-col>
                  <a-col :md="4" :sm="8">
                    <a-form-item label="科室图片" prop="departLogo">
                      <div class="num-wrap" :class="tabEditing ? 'is-editing' : 'is-readonly'"><a-input-number :min="0" v-model="form.departLogo" :disabled="!tabEditing" placeholder="请输入"></a-input-number><span class="suffix">分</span></div>
                    </a-form-item>
                  </a-col>
                  <a-col :md="4" :sm="8">
                    <a-form-item label="医师注册" prop="doctorDepartRegister">
                      <div class="num-wrap" :class="tabEditing ? 'is-editing' : 'is-readonly'"><a-input-number :min="0" v-model="form.doctorDepartRegister" :disabled="!tabEditing" placeholder="请输入"></a-input-number><span class="suffix">分/人</span></div>
                    </a-form-item>
                  </a-col>
                
                  <a-col :md="4" :sm="8">
                    <a-form-item label="科室注册（三级医院）" prop="departLevelThree">
                      <div class="num-wrap" :class="tabEditing ? 'is-editing' : 'is-readonly'"><a-input-number :min="0" v-model="form.departLevelThree" :disabled="!tabEditing" placeholder="请输入"></a-input-number><span class="suffix">分</span></div>
                    </a-form-item>
                  </a-col>
                  <a-col :md="4" :sm="8">
                    <a-form-item label="科室注册（二级医院）" prop="departLevelTwo">
                      <div class="num-wrap" :class="tabEditing ? 'is-editing' : 'is-readonly'"><a-input-number :min="0" v-model="form.departLevelTwo" :disabled="!tabEditing" placeholder="请输入"></a-input-number><span class="suffix">分</span></div>
                    </a-form-item>
                  </a-col>
                  <a-col :md="4" :sm="8">
                    <a-form-item label="科室注册（一级医院）" prop="departLevelOne">
                      <div class="num-wrap" :class="tabEditing ? 'is-editing' : 'is-readonly'"><a-input-number :min="0" v-model="form.departLevelOne" :disabled="!tabEditing" placeholder="请输入"></a-input-number><span class="suffix">分</span></div>
                    </a-form-item>
                  </a-col>
                
                <a-col :md="4" :sm="8">
                  <a-form-item label="全国百强科室" prop="topOneHundred">
                    <div class="num-wrap" :class="tabEditing ? 'is-editing' : 'is-readonly'"><a-input-number :min="0" v-model="form.topOneHundred" :disabled="!tabEditing" placeholder="请输入"></a-input-number><span class="suffix">分</span></div>
                  </a-form-item>
                </a-col>
                <a-col :md="4" :sm="8">
                  <a-form-item label="基础分" prop="departBasic">
                    <div class="num-wrap" :class="tabEditing ? 'is-editing' : 'is-readonly'"><a-input-number :min="0" v-model="form.departBasic" :disabled="!tabEditing" placeholder="请输入"></a-input-number><span class="suffix">%(医院总分)</span></div>
                  </a-form-item>
                </a-col>
                <a-col :md="4" :sm="8">
                  <a-form-item label="本院最好科室" prop="bestDepart">
                    <div class="num-wrap" :class="tabEditing ? 'is-editing' : 'is-readonly'"><a-input-number :min="0" v-model="form.bestDepart" :disabled="!tabEditing" placeholder="请输入"></a-input-number><span class="suffix">分</span></div>
                  </a-form-item>
                </a-col>
              
                <a-col :md="4" :sm="8">
                  <a-form-item label="科室国内名医数量" prop="departNationalFamousDoctorCount">
                    <div class="num-wrap" :class="tabEditing ? 'is-editing' : 'is-readonly'"><a-input-number :min="0" v-model="form.departNationalFamousDoctorCount" :disabled="!tabEditing" placeholder="请输入"></a-input-number><span class="suffix">分</span></div>
                  </a-form-item>
                </a-col>
                <a-col :md="4" :sm="8">
                  <a-form-item label="科室省内名医数量" prop="departProvinceFamousDoctorCount">
                    <div class="num-wrap" :class="tabEditing ? 'is-editing' : 'is-readonly'"><a-input-number :min="0" v-model="form.departProvinceFamousDoctorCount" :disabled="!tabEditing" placeholder="请输入"></a-input-number><span class="suffix">分</span></div>
                  </a-form-item>
                </a-col>
              </a-row>
              <div class="tab-actions">
                <a-button v-if="!tabEditing" type="primary" @click="startEdit">编辑</a-button>
                <template v-else>
                  <a-button type="primary" :loading="submitLoading" @click="saveTab">保存</a-button>
                  <a-button :disabled="submitLoading" style="margin-left: 8px;" @click="cancelEdit">取消</a-button>
                </template>
              </div>
            </a-tab-pane>
            <a-tab-pane key="3" tab="医师华歧系数规则配置">
              <a-row :gutter="20">
                <a-col :md="4" :sm="8">
                  <a-form-item label="主任医师、教授、主任中医师或主任技师" prop="directorOrProfessor">
                    <div class="num-wrap" :class="tabEditing ? 'is-editing' : 'is-readonly'"><a-input-number :min="0" v-model="form.directorOrProfessor" :disabled="!tabEditing" placeholder="请输入"></a-input-number><span class="suffix">分</span></div>
                  </a-form-item>
                </a-col>
                <a-col :md="4" :sm="8">
                  <a-form-item label="副主任医师、副教授、副主任中医师或副主任技师" prop="deputyOrAssociate">
                    <div class="num-wrap" :class="tabEditing ? 'is-editing' : 'is-readonly'"><a-input-number :min="0" v-model="form.deputyOrAssociate" :disabled="!tabEditing" placeholder="请输入"></a-input-number><span class="suffix">分</span></div>
                  </a-form-item>
                </a-col>
                <a-col :md="4" :sm="8">
                  <a-form-item label="主治医师、主治中医师" prop="attendingPhysician">
                    <div class="num-wrap" :class="tabEditing ? 'is-editing' : 'is-readonly'"><a-input-number :min="0" v-model="form.attendingPhysician" :disabled="!tabEditing" placeholder="请输入"></a-input-number><span class="suffix">分</span></div>
                  </a-form-item>
                </a-col>
                <a-col :md="4" :sm="8">
                  <a-form-item label="医师、住院医师、中医师" prop="physician">
                    <div class="num-wrap" :class="tabEditing ? 'is-editing' : 'is-readonly'"><a-input-number :min="0" v-model="form.physician" :disabled="!tabEditing" placeholder="请输入"></a-input-number><span class="suffix">分</span></div>
                  </a-form-item>
                </a-col>
              
                <a-col :md="4" :sm="8">
                  <a-form-item label="主任委员、副主任委员、主委或副主委" prop="chairViceChair">
                    <div class="num-wrap" :class="tabEditing ? 'is-editing' : 'is-readonly'"><a-input-number :min="0" v-model="form.chairViceChair" :disabled="!tabEditing" placeholder="请输入"></a-input-number><span class="suffix">分</span></div>
                  </a-form-item>
                </a-col>
                <a-col :md="4" :sm="8">
                  <a-form-item label="常委或常务委员" prop="standCommitteeMember">
                    <div class="num-wrap" :class="tabEditing ? 'is-editing' : 'is-readonly'"><a-input-number :min="0" v-model="form.standCommitteeMember" :disabled="!tabEditing" placeholder="请输入"></a-input-number><span class="suffix">分</span></div>
                  </a-form-item>
                </a-col>
                <a-col :md="4" :sm="8">
                  <a-form-item label="委员" prop="committeeMember">
                    <div class="num-wrap" :class="tabEditing ? 'is-editing' : 'is-readonly'"><a-input-number :min="0" v-model="form.committeeMember" :disabled="!tabEditing" placeholder="请输入"></a-input-number><span class="suffix">分</span></div>
                  </a-form-item>
                </a-col>
                <a-col :md="4" :sm="8">
                  <a-form-item label="医生工龄" prop="workYears">
                    <div class="num-wrap" :class="tabEditing ? 'is-editing' : 'is-readonly'"><a-input-number :min="0" v-model="form.workYears" :disabled="!tabEditing" placeholder="请输入"></a-input-number><span class="suffix">分</span></div>
                  </a-form-item>
                </a-col>
              
                <a-col :md="4" :sm="8">
                  <a-form-item label="名医荣誉（国家级）" prop="nationalHonor">
                    <div class="num-wrap" :class="tabEditing ? 'is-editing' : 'is-readonly'"><a-input-number :min="0" v-model="form.nationalHonor" :disabled="!tabEditing" placeholder="请输入"></a-input-number><span class="suffix">分</span></div>
                  </a-form-item>
                </a-col>
                <a-col :md="4" :sm="8">
                  <a-form-item label="名医荣誉（省级）" prop="provinceHonor">
                    <div class="num-wrap" :class="tabEditing ? 'is-editing' : 'is-readonly'"><a-input-number :min="0" v-model="form.provinceHonor" :disabled="!tabEditing" placeholder="请输入"></a-input-number><span class="suffix">分</span></div>
                  </a-form-item>
                </a-col>
                <a-col :md="4" :sm="8">
                  <a-form-item label="医师注册" prop="doctorRegister">
                    <div class="num-wrap" :class="tabEditing ? 'is-editing' : 'is-readonly'"><a-input-number :min="0" v-model="form.doctorRegister" :disabled="!tabEditing" placeholder="请输入"></a-input-number><span class="suffix">分</span></div>
                  </a-form-item>
                </a-col>
                <a-col :md="4" :sm="8">
                  <a-form-item label="基础分" prop="doctorBasic">
                    <div class="num-wrap" :class="tabEditing ? 'is-editing' : 'is-readonly'"><a-input-number :min="0" v-model="form.doctorBasic" :disabled="!tabEditing" placeholder="请输入"></a-input-number><span class="suffix">%(医院总分)</span></div>
                  </a-form-item>
                </a-col>
                <a-col :md="4" :sm="8">
                  <a-form-item label="科室基础分" prop="doctorDepartmentBasic">
                    <div class="num-wrap" :class="tabEditing ? 'is-editing' : 'is-readonly'"><a-input-number :min="0" v-model="form.doctorDepartmentBasic" :disabled="!tabEditing" placeholder="请输入"></a-input-number><span class="suffix">%(科室总分)</span></div>
                  </a-form-item>
                </a-col>
              
                <a-col :md="4" :sm="8">
                  <a-form-item label="三级医院推荐" prop="thirdHospitalRec">
                    <div class="num-wrap" :class="tabEditing ? 'is-editing' : 'is-readonly'"><a-input-number :min="0" v-model="form.thirdHospitalRec" :disabled="!tabEditing" placeholder="请输入"></a-input-number><span class="suffix">分/人</span></div>
                  </a-form-item>
                </a-col>
                <a-col :md="4" :sm="8">
                  <a-form-item label="二级医院推荐" prop="secondHospitalRec">
                    <div class="num-wrap" :class="tabEditing ? 'is-editing' : 'is-readonly'"><a-input-number :min="0" v-model="form.secondHospitalRec" :disabled="!tabEditing" placeholder="请输入"></a-input-number><span class="suffix">分/人</span></div>
                  </a-form-item>
                </a-col>
                <a-col :md="4" :sm="8">
                  <a-form-item label="三级医院科室推荐" prop="thirdDepartRec">
                    <div class="num-wrap" :class="tabEditing ? 'is-editing' : 'is-readonly'"><a-input-number :min="0" v-model="form.thirdDepartRec" :disabled="!tabEditing" placeholder="请输入"></a-input-number><span class="suffix">分/人</span></div>
                  </a-form-item>
                </a-col>
                <a-col :md="4" :sm="8">
                  <a-form-item label="二级医院科室推荐" prop="secondDepartRec">
                    <div class="num-wrap" :class="tabEditing ? 'is-editing' : 'is-readonly'"><a-input-number :min="0" v-model="form.secondDepartRec" :disabled="!tabEditing" placeholder="请输入"></a-input-number><span class="suffix">分/人</span></div>
                  </a-form-item>
                </a-col>
              
                <a-col :md="4" :sm="8">
                  <a-form-item label="医师推荐顶级医师" prop="doctorRec">
                    <div class="num-wrap" :class="tabEditing ? 'is-editing' : 'is-readonly'"><a-input-number :min="0" v-model="form.doctorRec" :disabled="!tabEditing" placeholder="请输入"></a-input-number><span class="suffix">分/次</span></div>
                  </a-form-item>
                </a-col>
                <a-col :md="4" :sm="8">
                  <a-form-item label="医师推荐顶级医师封顶" prop="doctorRecMax">
                    <div class="num-wrap" :class="tabEditing ? 'is-editing' : 'is-readonly'"><a-input-number :min="0" v-model="form.doctorRecMax" :disabled="!tabEditing" placeholder="请输入"></a-input-number><span class="suffix">分封顶</span></div>
                  </a-form-item>
                </a-col>
                <a-col :md="4" :sm="8">
                  <a-form-item label="平台推荐三级医院医师" prop="thirdDoctorRec">
                    <div class="num-wrap" :class="tabEditing ? 'is-editing' : 'is-readonly'"><a-input-number :min="0" v-model="form.thirdDoctorRec" :disabled="!tabEditing" placeholder="请输入"></a-input-number><span class="suffix">分/人</span></div>
                  </a-form-item>
                </a-col>
                <a-col :md="4" :sm="8">
                  <a-form-item label="平台推荐二级医院医师" prop="secondDoctorRec">
                    <div class="num-wrap" :class="tabEditing ? 'is-editing' : 'is-readonly'"><a-input-number :min="0" v-model="form.secondDoctorRec" :disabled="!tabEditing" placeholder="请输入"></a-input-number><span class="suffix">分/人</span></div>
                  </a-form-item>
                </a-col>
                <a-col :md="4" :sm="8">
                  <a-form-item label="名校毕业" prop="prestigiousSchool">
                    <div class="num-wrap" :class="tabEditing ? 'is-editing' : 'is-readonly'"><a-input-number :min="0" v-model="form.prestigiousSchool" :disabled="!tabEditing" placeholder="请输入"></a-input-number><span class="suffix">分</span></div>
                  </a-form-item>
                </a-col>
              
                <a-col :md="4" :sm="8">
                  <a-form-item label="点赞加分" prop="like">
                    <div class="num-wrap" :class="tabEditing ? 'is-editing' : 'is-readonly'"><a-input-number :min="0" v-model="form.like" :disabled="!tabEditing" placeholder="请输入"></a-input-number><span class="suffix">分</span></div>
                  </a-form-item>
                </a-col>
                <a-col :md="4" :sm="8">
                  <a-form-item label="被转发加分" prop="trans">
                    <div class="num-wrap" :class="tabEditing ? 'is-editing' : 'is-readonly'"><a-input-number :min="0" v-model="form.trans" :disabled="!tabEditing" placeholder="请输入"></a-input-number><span class="suffix">分</span></div>
                  </a-form-item>
                </a-col>
                <a-col :md="4" :sm="8">
                  <a-form-item label="顶级医师评选" prop="topPhysician">
                    <div class="num-wrap" :class="tabEditing ? 'is-editing' : 'is-readonly'"><a-input-number :min="0" v-model="form.topPhysician" :disabled="!tabEditing" placeholder="请输入"></a-input-number><span class="suffix">分</span></div>
                  </a-form-item>
                </a-col>
                <a-col :md="4" :sm="8">
                  <a-form-item label="最好医师评选" prop="bestPhysician">
                    <div class="num-wrap" :class="tabEditing ? 'is-editing' : 'is-readonly'"><a-input-number :min="0" v-model="form.bestPhysician" :disabled="!tabEditing" placeholder="请输入"></a-input-number><span class="suffix">分</span></div>
                  </a-form-item>
                </a-col>
              </a-row>
              <div class="tab-actions">
                <a-button v-if="!tabEditing" type="primary" @click="startEdit">编辑</a-button>
                <template v-else>
                  <a-button type="primary" :loading="submitLoading" @click="saveTab">保存</a-button>
                  <a-button :disabled="submitLoading" style="margin-left: 8px;" @click="cancelEdit">取消</a-button>
                </template>
              </div>
            </a-tab-pane>
            <a-tab-pane key="4" tab="择医收费配置">
              <a-row :gutter="20">
                <a-col :md="4" :sm="8">
                  <a-form-item label="AI择医收费" prop="aiPrice">
                    <div class="num-wrap" :class="tabEditing ? 'is-editing' : 'is-readonly'"><a-input-number :min="0" v-model="form.aiPrice" :disabled="!tabEditing" placeholder="请输入"></a-input-number><span class="suffix">医币</span></div>
                  </a-form-item>
                </a-col>
                  <a-col :md="4" :sm="8">
                  <a-form-item label="AI择医解锁收费" prop="aiUnlock">
                    <div class="num-wrap" :class="tabEditing ? 'is-editing' : 'is-readonly'"><a-input-number :min="0" v-model="form.aiUnlock" :disabled="!tabEditing" placeholder="请输入"></a-input-number><span class="suffix">医币</span></div>
                  </a-form-item>
                  </a-col>
                    <a-col :md="4" :sm="8">
                  <a-form-item label="自主择医收费" prop="autonomyPrice">
                    <div class="num-wrap" :class="tabEditing ? 'is-editing' : 'is-readonly'"><a-input-number :min="0" v-model="form.autonomyPrice" :disabled="!tabEditing" placeholder="请输入"></a-input-number><span class="suffix">医币</span></div>
                  </a-form-item>
                    </a-col>
                      <a-col :md="4" :sm="8">
                  <a-form-item label="自主择医解锁收费" prop="autonomyUnlock">
                    <div class="num-wrap" :class="tabEditing ? 'is-editing' : 'is-readonly'"><a-input-number :min="0" v-model="form.autonomyUnlock" :disabled="!tabEditing" placeholder="请输入"></a-input-number><span class="suffix">医币</span></div>
                  </a-form-item>
                </a-col>
              
                <a-col :md="4" :sm="8">
                  <a-form-item label="人工择医收费" prop="manualPrice">
                    <div class="num-wrap" :class="tabEditing ? 'is-editing' : 'is-readonly'"><a-input-number :min="0" v-model="form.manualPrice" :disabled="!tabEditing" placeholder="请输入"></a-input-number><span class="suffix">医币</span></div>
                  </a-form-item>
                </a-col>
                  <a-col :md="4" :sm="8">
                  <a-form-item label="人工择医解锁收费" prop="manualUnlock">
                    <div class="num-wrap" :class="tabEditing ? 'is-editing' : 'is-readonly'"><a-input-number :min="0" v-model="form.manualUnlock" :disabled="!tabEditing" placeholder="请输入"></a-input-number><span class="suffix">医币</span></div>
                  </a-form-item>
                  </a-col>
                    <a-col :md="4" :sm="8">
                  <a-form-item label="精准择医收费" prop="precisePrice">
                    <div class="num-wrap" :class="tabEditing ? 'is-editing' : 'is-readonly'"><a-input-number :min="0" v-model="form.precisePrice" :disabled="!tabEditing" placeholder="请输入"></a-input-number><span class="suffix">医币</span></div>
                  </a-form-item>
                    </a-col>
<!--                 <a-col :md="6" :sm="24">-->
<!--                  <a-form-item label="精准择医解锁收费" prop="like" >-->
<!--                    单条<a-input-number :min="0" v-model="form.preciseUnlock" placeholder="请输入" /> 医币-->
<!--                  </a-form-item>-->
<!--                </a-col>-->
              </a-row>
              <div class="tab-actions">
                <a-button v-if="!tabEditing" type="primary" @click="startEdit">编辑</a-button>
                <template v-else>
                  <a-button type="primary" :loading="submitLoading" @click="saveTab">保存</a-button>
                  <a-button :disabled="submitLoading" style="margin-left: 8px;" @click="cancelEdit">取消</a-button>
                </template>
              </div>
            </a-tab-pane>
          </a-tabs>
        </a-form>
      </div>
    </a-card>

</template>

<script>

import { tableMixin } from '@/store/table-mixin'
import { getConfig, saveConfig } from '@/api/recommend/config'

// 各 tab 对应的字段清单，保存时只提交当前 tab 中被修改过的字段 + type
const TAB_FIELDS = {
  '1': [
    'hospitalContent', 'hospitalLogo', 'haveDepart', 'eachDepartContent', 'eachDepartLogo', 'eachDoctorContent',
    'levelThreeRegister', 'levelTwoRegister', 'levelOneRegister',
    'levelThreeHospital', 'levelTwoHospital', 'levelOneHospital',
    'specializedLevelThree', 'specializedLevelTwo', 'specializedLevelOne',
    'oneToTen', 'elevenToTwenty', 'twentyOneToThirty', 'thirtyOneToFifty',
    'hospitalNationalFamousDoctorCount', 'hospitalProvinceFamousDoctorCount'
  ],
  '2': [
    'departContent', 'departLogo', 'doctorDepartRegister',
    'departLevelThree', 'departLevelTwo', 'departLevelOne',
    'topOneHundred', 'departBasic', 'bestDepart',
    'departNationalFamousDoctorCount', 'departProvinceFamousDoctorCount'
  ],
  '3': [
    'directorOrProfessor', 'deputyOrAssociate', 'attendingPhysician', 'physician',
    'chairViceChair', 'standCommitteeMember', 'committeeMember', 'workYears',
    'nationalHonor', 'provinceHonor', 'doctorRegister', 'doctorBasic', 'doctorDepartmentBasic',
    'thirdHospitalRec', 'secondHospitalRec', 'thirdDepartRec', 'secondDepartRec',
    'doctorRec', 'doctorRecMax', 'thirdDoctorRec', 'secondDoctorRec',
    'prestigiousSchool', 'like', 'trans', 'topPhysician', 'bestPhysician'
  ],
  '4': [
    'aiPrice', 'aiUnlock', 'autonomyPrice', 'autonomyUnlock',
    'manualPrice', 'manualUnlock', 'precisePrice'
  ]
}

// 各 tab 保存前的二次确认文案（触发重算的范围不同，提示需对应）
const TAB_CONFIRM_CONTENT = {
  '1': '保存后将重新计算全部医院的华歧系数分数，执行时间较长，请核对无误后再继续。',
  '2': '保存后将重新计算全部医院科室的华歧系数分数，执行时间较长，请核对无误后再继续。',
  '3': '保存后将重新计算全部医师的华歧系数分数，执行时间较长，请核对无误后再继续。'
}

// 汇总所有 tab 的字段，生成全字段默认 form：
// 1. 保证接口返回前/返回缺字段时 form 的 key 依然齐全（Vue2 无法侦测新增属性，key 缺失会导致赋值/还原不生效）
// 2. 避免接口未返回时进入编辑，快照到 undefined 导致取消时清空输入框
const DEFAULT_FORM = {}
Object.keys(TAB_FIELDS).forEach(tab => {
  TAB_FIELDS[tab].forEach(field => {
    DEFAULT_FORM[field] = null
  })
})

export default {
  name: 'RecommendConfig',

  mixins: [tableMixin],
  data () {
    return {
      activeKey: '1',
      submitLoading: false,
      savingTab: null, // 正在保存的 tab key，便于区分在途请求归属
      configReqSeq: 0, // getConfig 请求序号，防止旧响应覆盖新数据
      loaded: false, // 配置是否已加载完成（未加载前禁止编辑，防止快照到 undefined）
      editingTab: null, // 当前处于编辑态的 tab key（同一时刻最多一个，切走自动还原）
      backups: { '1': null, '2': null, '3': null, '4': null }, // 各 tab 独立的编辑前快照
      form: { ...DEFAULT_FORM }
    }
  },
  filters: {
  },
  created () {
    this.getConfig()
  },
  computed: {
    // 模板沿用的编辑态：仅当"正在编辑的 tab"是"当前展示的 tab"时为 true
    tabEditing () {
      return this.editingTab === this.activeKey
    }
  },
  watch: {
    // 切换页签时若有未保存的修改，先确认；确认后还原离开的页签，各页签互不影响
    activeKey (newKey, oldKey) {
      // 保存请求在途时禁止切换，避免请求回调作用于错误的页签状态
      if (this.submitLoading) {
        this.activeKey = oldKey
        this.$message.warning('正在保存，请稍候再切换', 2)
        return
      }
      if (this.editingTab !== oldKey) {
        return
      }
      // 先拦回原页签，待用户确认
      this.activeKey = oldKey
      this.$confirm({
        title: '当前页签有未保存的修改',
        content: '切换后将丢弃本页未保存的修改，是否继续？',
        okText: '放弃修改并切换',
        cancelText: '继续编辑',
        onOk: () => {
          this.restoreTab(oldKey)
          this.editingTab = null
          this.activeKey = newKey
        }
      })
    }
  },
  beforeRouteLeave (to, from, next) {
    // 保存请求在途时不允许离开，防止用户以为已保存完成却中途跳走
    if (this.submitLoading) {
      this.$message.warning('正在保存，请稍候再离开', 2)
      next(false)
      return
    }
    if (this.tabEditing) {
      this.$confirm({
        title: '当前页签有未保存的修改',
        content: '离开将丢弃修改，是否继续？',
        onOk: () => next(),
        onCancel: () => next(false)
      })
    } else {
      next()
    }
  },
  methods: {

    getConfig () {
      // 递增序号：只接受最新一次请求的响应，避免并发/迟到的旧响应覆盖新数据
      const seq = ++this.configReqSeq
      getConfig().then(res => {
        if (seq !== this.configReqSeq) {
          return
        }
        if (res.data) {
          this.loaded = true
          // 有页签处于编辑态时不整体刷新，避免覆盖正在编辑的值（保存成功的 tab 其 form 值与服务器已一致）
          if (this.editingTab === null) {
            this.form = { ...DEFAULT_FORM, ...res.data }
            // 数据已同步，清空历史快照
            this.backups = { '1': null, '2': null, '3': null, '4': null }
          }
        }
      })
    },

    // 进入编辑：备份当前 tab 字段值
    startEdit () {
      // 配置尚未加载完成时不允许进入编辑，否则快照到 undefined，取消时会把输入框清空
      if (!this.loaded) {
        this.$message.warning('配置加载中，请稍后再试', 2)
        return
      }
      const backup = {}
      TAB_FIELDS[this.activeKey].forEach(field => {
        backup[field] = this.form[field]
      })
      this.backups[this.activeKey] = backup
      this.editingTab = this.activeKey
    },

    // 取消编辑：还原快照
    cancelEdit () {
      // 保存在途时禁止取消，避免请求成功后状态已被清空导致显示错乱
      if (this.submitLoading) {
        this.$message.warning('正在保存，请稍候', 2)
        return
      }
      this.restoreTab()
      this.editingTab = null
    },

    // 还原指定 tab 的快照（不传 key 则还原当前 tab）
    restoreTab (key) {
      const tabKey = key || this.activeKey
      const backup = this.backups[tabKey]
      if (!backup) {
        return
      }
      TAB_FIELDS[tabKey].forEach(field => {
        this.form[field] = backup[field]
      })
    },

    // 保存当前 tab：只提交本次编辑中被修改过的字段
    saveTab () {
      // 防重入：已有保存在途时忽略后续触发（如连点保存按钮）
      if (this.submitLoading) {
        return
      }
      const tabKey = this.activeKey
      const fields = TAB_FIELDS[tabKey]
      const data = { type: Number(tabKey) }
      const backup = this.backups[tabKey] || {}
      const cleared = [] // 原来有值却被清空的字段
      let changed = false
      fields.forEach(field => {
        const oldVal = backup[field]
        const newVal = this.form[field]
        // 未修改的字段不提交
        if (newVal === oldVal) {
          return
        }
        // 后端按"非空合并"更新（ignoreNullValue），已有值被清空无法生效，阻止保存
        if (newVal === null || newVal === undefined || newVal === '') {
          cleared.push(field)
          return
        }
        data[field] = newVal
        changed = true
      })
      if (cleared.length > 0) {
        this.$message.warning('已有配置项不能清空，请填写数值后再保存', 3)
        return
      }
      if (!changed) {
        this.$message.info('本次没有修改', 2)
        this.editingTab = null
        return
      }
      // 择医收费(type=4)保存不触发分数重算，直接提交；其余 tab 按各自重算范围二次确认
      if (Number(tabKey) === 4) {
        this.doSave(data, tabKey)
        return
      }
      this.$confirm({
        title: '确认保存？',
        content: TAB_CONFIRM_CONTENT[tabKey],
        okText: '确认保存',
        cancelText: '再看看',
        // 弹窗确认按钮进入 loading（doSave 返回 Promise），防止连点确认造成重复提交
        onOk: () => this.doSave(data, tabKey)
      })
    },
    // 真正提交保存（tabKey 闭包捕获，防止请求期间切换页签后误改新页签状态）
    // 返回 Promise，供 $confirm 的 onOk 驱动确认按钮 loading
    doSave (data, tabKey) {
      // 防重入：双重保险，避免任何路径产生并发请求
      if (this.submitLoading) {
        return Promise.resolve()
      }
      this.submitLoading = true
      this.savingTab = tabKey
      return saveConfig(data).then(res => {
        if (res.success) {
          this.$message.success('保存成功', 3)
          if (this.editingTab === tabKey) {
            this.editingTab = null
          }
          // 保存成功后同步快照，使"本次没有修改"的判断基于最新提交值
          this.backups[tabKey] = null
          // 重新获取配置以更新数据
          this.getConfig()
        } else {
          this.$message.error(`保存失败，${res.message}`, 3)
        }
      }).catch(() => {
        // 异常提示已由 request 拦截器统一处理，此处仅捕获以免 Promise 链中断
      }).finally(() => {
        this.submitLoading = false
        this.savingTab = null
      })
    }
  }
}
</script>
<style lang="less" scoped>
  .platformConfig{
    min-height: 800px;
  }
  .notice{
    margin-bottom: 20px;
  }
  .notice-list{
    margin: 0;
    padding-left: 18px;
    line-height: 1.9;
  }

  /* ===== 表单项：标签在上、胶囊在下 ===== */
  /deep/ .ant-form-item{
    display: flex;
    flex-direction: column;
    align-items: stretch;
    margin-bottom: 0;
  }
  /deep/ .ant-form-item-label{
    /* 撑满列宽，保证标签有足够宽度正常换行 */
    flex: none;
    width: 100%;
    max-width: 100%;
    padding: 0 0 7px;
    text-align: left;
    color: #3d4757;
    font-size: 13px;
    font-weight: 400;
    line-height: 20px;
    white-space: normal;
    word-break: normal;
    overflow-wrap: break-word;
    /* 固定两行高度，长短标签所在行严格对齐 */
    height: 47px;
  }
  /deep/ .ant-form-item-label > label{
    display: block;
    width: 100%;
    color: #3d4757;
    font-size: 13px;
    font-weight: 400;
    line-height: 20px;
  }
  /* 冒号紧跟文字 */
  /deep/ .ant-form-item-label > label:after{
    margin: 0 2px 0 0;
  }
  /* 去掉 label 的单行截断，允许完整换行显示 */
  /deep/ .ant-form-item-label > label{
    white-space: normal;
    text-overflow: clip;
    /* 清除 Ant Design 为冒号/必填星号预留的伪元素占位 */
    margin-right: 0;
  }
  /deep/ .ant-form-item-label > label:before{
    display: none;
  }
  /deep/ .ant-form-item-control-wrapper{
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }

  /* ===== 数值 + 单位：输入框 + 右侧单位小标签，构成一个整体的"数值胶囊" ===== */
  /deep/ .num-wrap{
    display: flex;
    align-items: center;
    /* 胶囊占满整行，保证所有输入框等宽、左边缘对齐 */
    flex: 0 0 100%;
    width: 100%;
    min-width: 0;
    height: 32px;
    border: 1px solid #e2e6ec;
    border-radius: 6px;
    background: #fff;
    overflow: hidden;
    transition: border-color .2s, box-shadow .2s;
  }
  /* 输入框本体：去掉自身边框，与外部胶囊容器合为一体，宽度固定保证各框等宽 */
  /deep/ .ant-input-number{
    flex: 1 1 auto;
    width: auto;
    /* 防止在窄列下被压缩塌陷 */
    min-width: 60px;
    height: 30px;
    border: none;
    border-radius: 0;
    box-shadow: none;
    background-color: transparent;
  }
  /deep/ .ant-input-number input{
    height: 30px;
    line-height: 30px;
    padding: 0 10px;
    text-align: right;
    color: #1f2329;
    font-weight: 600;
    font-size: 14px;
  }
  /* 隐藏数字增减箭头：编辑态不再挤压数值区域，外观与只读态保持一致 */
  /deep/ .ant-input-number-handler-wrap{
    display: none;
  }
  /* 单位：作为胶囊右侧的浅色分区，与数值形成主次层次 */
  /deep/ .suffix{
    display: flex;
    align-items: center;
    align-self: stretch;
    flex: none;
    padding: 0 10px;
    color: #5b6675;
    font-size: 12.5px;
    white-space: nowrap;
    background: #f2f5f9;
    border-left: 1px solid #e6ebf2;
  }

  /* ===== 编辑态：整体胶囊高亮；聚焦时蓝色描边与光圈 ===== */
  /deep/ .num-wrap.is-editing:hover{
    border-color: #a8c6f5;
  }
  /deep/ .num-wrap.is-editing:focus-within{
    border-color: #4b8bf5;
    box-shadow: 0 0 0 2px rgba(75,139,245,.14);
  }
  /deep/ .ant-input-number-focused{
    border: none !important;
    box-shadow: none !important;
  }

  /* ===== 只读态：胶囊边框与底色更淡，数值加深，一眼区分编辑与否 ===== */
  /deep/ .num-wrap.is-readonly{
    border-color: #e8ebf0;
    background: #fcfdfe;
  }
  /deep/ .num-wrap.is-readonly:hover{
    border-color: #e8ebf0;
    box-shadow: none;
  }
  /deep/ .num-wrap.is-readonly .suffix{
    background: #f7f9fc;
  }
  /deep/ .ant-input-number-disabled{
    background-color: transparent;
  }
  /deep/ .ant-input-number-disabled input{
    color: #1f2329;
    cursor: default;
    font-weight: 600;
    -webkit-text-fill-color: #1f2329;
  }

  /* ===== 栅格：每行 5 个（大屏），小屏自动降列 ===== */
  /deep/ .ant-row{
    display: flex;
    flex-wrap: wrap;
    margin-left: 0;
    margin-right: 0;
  }
  /* 只作用于外层布局列，排除 form-item 内部的 label/control 栅格 */
  /deep/ .ant-col:not(.ant-form-item-label):not(.ant-form-item-control-wrapper){
    /* 覆盖 Ant Design 栅格宽度，固定为 20% = 每行 5 个 */
    flex: 0 0 20% !important;
    max-width: 20% !important;
    /* 列内左右留白，避免相邻项粘连 */
    padding-left: 12px;
    padding-right: 12px;
    margin-bottom: 22px;
    box-sizing: border-box;
  }
  /* form-item 内部的 label / control 列：占满整行，正常换行 */
  /deep/ .ant-form-item-label,
  /deep/ .ant-form-item-control-wrapper{
    flex: 1 1 100% !important;
    width: 100% !important;
    max-width: 100% !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  /* 中等屏幕每行 4 个 */
  @media (max-width: 1400px) {
    /deep/ .ant-col:not(.ant-form-item-label):not(.ant-form-item-control-wrapper){
      flex: 0 0 25% !important;
      max-width: 25% !important;
    }
  }
  /* 窄屏每行 2 个 */
  @media (max-width: 900px) {
    /deep/ .ant-col:not(.ant-form-item-label):not(.ant-form-item-control-wrapper){
      flex: 0 0 50% !important;
      max-width: 50% !important;
    }
  }

  /* ===== 操作条：右对齐，与内容用细线分隔 ===== */
  .tab-actions{
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    margin-top: 4px;
    padding-top: 16px;
    border-top: 1px solid #f0f2f5;
  }
  .tab-actions /deep/ .ant-btn{
    min-width: 84px;
    height: 34px;
    border-radius: 6px;
    font-weight: 400;
  }
  /* 页签标题 */
  /deep/ .ant-tabs__item{
    font-weight: 400;
  }
  /* 页签内容区上边距，与行间距呼应 */
  /deep/ .ant-tabs__content{
    padding-top: 20px;
  }
</style>
